import React, { useEffect, useState } from 'react';
import { Button, Card, Layout, notification, Modal, Table, Tag, DatePicker, Input, Row, Col, Space, Upload, message, Select } from 'antd';
import SideBar from '../SideBar';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';
import Search from 'antd/lib/input/Search';
import { getBookingAL, getBookingALLoading, updateBooking, updateBookingLoading } from '../../actions/bookingActions';
import dayjs from 'dayjs';
import TextArea from 'antd/lib/input/TextArea';
import { SearchOutlined, UploadOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { get_mcm_url, get_v10_url } from '../../utils/commonUtilities';
import axios from 'axios';
import InitialLoading from '../../Containers/InitialLoading';
import GlobalLoading from '../../Containers/GlobalLoading';
import BookingDetails from './BookingDetails';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Filter from '../../Components/Filter';
import BookingIcon from '../../Assets/images/sidebar-icons/booking.svg'
import ViewDetailsIcon from '../../Assets/images/view-details-icon.svg'
import NewBookingIcon from '../../Assets/images/new-booking-icon.svg'
import ReadBookingIcon from '../../Assets/images/booking-read-icon.svg'


const filterIcon = (
  <svg width="20" height="12" viewBox="0 0 25 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0H25V2.47059H0V0ZM4.16667 5.76471H20.8333V8.23529H4.16667V5.76471ZM9.16667 11.5294H15.8333V14H9.16667V11.5294Z" fill="#484A47"/>
  </svg>
)

const { Option } = Select;
const { RangePicker } = DatePicker
const MAPPING = {
  name: "userName",
  number: "userMobileNumber",
  alNumber: "alNumber",
  ipNumber: "ipNumber",
}
function Bookings(props) {
  const [rentDetailsFlag, setRentDetailsFlag] = useState(false)
  const [selectedBooking, setSelectedBooking] = useState()
  const [alLetterDetails, setAlLetterDetails] = useState({})
  const [insuranceDocuments, setInsuranceDocuments] = useState({})
  const [queryDocuments, setQueryDocuments] = useState({})
  const [docModalFlag, setDocModalFlag] = useState(false)
  const [alLetterFlag, setAlLetterFlag] = useState(false)
  const [queryDocFlag, setQueryDocFlag] = useState(false)
  const dateFormat = 'DD-MMM-YYYY';
  const timeFormat = 'hh:mm A';
  // const [patientStatus,setPatientStatus]=useState('Pending');
  const [search, setSearch] = useState({ userName: "", userMobileNumber: "", alNumber: "", ipNumber: "" })
  const [expandedRowKeys, setExpandRowKeys] = useState([])
  const [modalData, setModalData] = useState({});
  const [filterModal, setFilterModal] = useState(false)

  const history = useHistory();


  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 10,
    total: 10,
    searchParams: {
      alNumber: "",
      // ipNumber: "",
      userName: "",
      userMobileNumber: "",
      preAuthStatus: "",
    },
    filters: {}
  })


  const getColumnSearchProps = (dataIndex, placeholder, searchProp, type) => ({
    filterDropdown: ({ confirm, clearFilters, selectedKeys, setSelectedKeys }) => {
      return (<div style={{ padding: 8 }}>
        <Input
          placeholder={placeholder}
          value={search[MAPPING[dataIndex]]}
          onChange={e => { setSearch({ ...search, [MAPPING[dataIndex]]: e.target.value }) }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, MAPPING[dataIndex], searchProp)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, MAPPING[dataIndex], searchProp)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => {
            // setSelectedKeys([])
            handle_reset(clearFilters, data, MAPPING[dataIndex], searchProp)
          }
          } size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>)
    },
    filterIcon: filtered => <SearchOutlined style={{ color: search[MAPPING[dataIndex]] !== "" ? '#1890ff' : undefined }} />,

    render: text =>
      search[MAPPING[dataIndex]] === "" ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={search[MAPPING[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
          title={text}
        />
      ) : (
        text
      ),
  });

  useEffect(() => {
    props.setActiveSideKey('1')
  }, [])



  useEffect(() => {

    if (props.updateBookingRet) {
      // console.log(props.updateBookingRet,'here')
      if (props.updateBookingRet.success) {

        const newData = data.map(item => {
          if (item._id === props.updateBookingRet.data._id) {
            const booking = props.updateBookingRet.data;
            // console.log("HERE",booking)
            let apAmount = booking.paymentDetails? booking.paymentDetails.finalApproved ? booking.paymentDetails.finalApproved : booking.paymentDetails.initialApproved ? booking.paymentDetails.initialApproved : 0 : 0
            return {
              _id: booking._id,
              time: dayjs(booking.createdAt).format(timeFormat),
              date: dayjs(booking.createdAt).format(dateFormat),
              name: booking.patientName,
              alNumber: booking.alNumber,
              netSanctionedAmount: booking.netSanctionedAmount ? booking.netSanctionedAmount : "Not Updated Yet",
              status: booking.preAuthStatus,
              paymentDetails: booking.paymentDetails,
              alLetterDetails: booking.alLetterDetails,
              cardNumber: booking.cardNumber,
              ipNumber: booking.ipNumber,
              dischargeDoc: booking.dischargeDoc,
              dod: booking.dod,
              doa: booking.doa,
              queryDoc: booking.queryDoc,
              hasReport: booking.userReportId,
              reportImages: booking.userReportId ? booking.reportImages : null,
              reportPdfs: booking.userReportId ? booking.reportPdfs : null,
              haveInsurance: booking.haveInsurance,
              documents: booking.insuranceDetails,
              remarks: booking.remarks,
              utr: booking.paymentDetails ? booking.paymentDetails.utr : null,
              alLetterUrl: booking.alLetterUrl,
              hospitalName: booking.professionalName,
              hospitalAddress: booking.professionalAddress,
              hospitalNumber: booking.professionalMobileNumber,
              policyNumber: booking.insuranceDetails ? booking.insuranceDetails.policyNumber : "N/A",
              patientStatus: booking.patientStatus,
              number: booking.patientMobileNumber,
              plNumber: booking?.plNumber,
              estimatedCost: booking?.paymentDetails?.sourcingCost,
              finalBill: booking?.paymentDetails?.finalBill,
              totalBill: booking?.paymentDetails?.totalBill,
              discountAmount: booking?.paymentDetails?.discount,
              approvedAmount: apAmount,
              amountDue: parseInt(apAmount) - parseInt((booking.paymentDetails && booking.paymentDetails.settledAmount) ? booking.paymentDetails.settledAmount : 0),
              settledAmount: booking?.paymentDetails?.settledAmount

            }

          }
          else return item;
        })
        setData(newData);
        message.success(`Booking updated`);
      } else {
        openNotificationWithIcon()
      }
      props.updateBookingLoading()
    }
  }, [props.updateBookingRet])



  const patientStatusHandler = (patientStatus, bookingId) => {
    props.updateBooking({ bookingId, patientStatus });
  }

  const handleUpdateReadStatus = (bookingId) => {
    const headers = {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    }
    const body = {
      newBooking: false
    }
    axios.post(`${get_v10_url()}/professional/markBookingRead?bookingId=${bookingId}`, body, {headers})
    .then(res => {
      // console.warn(res)
    })
    .catch(err => {
      console.error(err)
    })
  }

  const columns = [
    {
      title: 'PL Number',
      dataIndex: 'plNumber',
      key: 'plNumber',
      // ...getColumnSearchProps('name', "Search Name", 'name'),
      width: "1%",
      fixed: 'left',
      render: (text, record) => <div className='view-details-container' onClick={()=>{window.open(`/dashboard/booking/booking-details?id=${record._id}`); handleUpdateReadStatus(record._id)}} style={{cursor:'pointer'}}>
        <img src={record.isNewBooking ? NewBookingIcon : ReadBookingIcon} alt='icon'/>
        <span>{text ? text : '-'}</span>
        <p className='view-details'>View Details</p>
      </div>,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      // ...getColumnSearchProps('name', "Search Name", 'name'),
      width: "1%",
      fixed: 'left',
      render: (text, record) => <span>{text ? text : '-'}</span>
    },
    // {
    //   title: 'Number',
    //   dataIndex: 'number',
    //   key: 'number',
    //   ...getColumnSearchProps('number', "Search Number", 'number'),
    //   width: "1%",
    //   render: text => <span>{text}</span>,
    // },
    // {
    //   title: 'AL Letter',
    //   dataIndex: 'alLetterUrl',
    //   key: 'alLetterUrl',
    //   width: "1%",
    //   render: (text, record) => record.alLetterDetails && record.alLetterDetails.updated ? <Button className="edit-session-button" onClick={(e) => {
    //     e.preventDefault()
    //     setAlLetterDetails(record.alLetterDetails)
    //     setAlLetterFlag(true)
    //   }}>View AL Letters</Button> : "Not Updated Yet",
    // },
    {
      title: 'AL Number',
      dataIndex: 'alNumber',
      key: 'alNumber',
      // ...getColumnSearchProps('alNumber', "Search AL Number", 'alNumber'),
      width: "1%",
      render: (text, record) => <span>{text ? text : '-'}</span>,
    },
    // {
    //   title: 'Estimated Cost',
    //   dataIndex: 'estimatedCost',
    //   key: 'estimatedCost',
    //   width: "1%",
    //   render: text => <span>{ text ? text == 0 ? "-" : `₹${text}` : "-"}</span>,
    // },
    // {
    //   title: 'Total Bill',
    //   dataIndex: 'totalBill',
    //   key: 'totalBill',
    //   width: "1%",
    //   render: text => <span>{ text ? text == 0 ? "-" : `₹${text}` : "-"}</span>,
    // },
    // {
    //   title: 'Final Bill',
    //   dataIndex: 'finalBill',
    //   key: 'finalBill',
    //   width: "1%",
    //   render: text => <span>{ text ? text == 0 ? "-" : `₹${text}` : "-"}</span>,
    // },
    // {
    //   title: 'Approved Amount',
    //   dataIndex: 'approvedAmount',
    //   key: 'approvedAmount',
    //   width: "1%",
    //   render: text => <span>{ text ? text == 0 ? "-" : `₹${text}` : "-"}</span>,
    // },
    // {
    //   title: 'Settled Amount',
    //   dataIndex: 'settledAmount',
    //   key: 'settledAmount',
    //   width: "1%",
    //   render: text => <span>{ text ? text == 0 ? "-" : `₹${text}` : "-"}</span>,
    // },
    // {
    //   title: 'Amount Due',
    //   dataIndex: 'amountDue',
    //   key: 'amountDue',
    //   width: "1%",
    //   render: text => <span>{ text ? text == 0 ? "-" : `₹${text}` : "-"}</span>,
    // },
    // {
    //   title: 'UTR',
    //   dataIndex: 'utr',
    //   key: 'utr',
    //   width: "1%",
    //   render: text => text ? <span>{text}</span> : "Not Updated Yet",
    // },
    // {
    //   title: 'IPD Number',
    //   dataIndex: 'ipNumber',
    //   key: 'ipNumber',
    //   width: "1%",
    //   // ...getColumnSearchProps('ipNumber', "Search IP Number", 'ipNumber'),
    //   render: (text, record) => <span style={{ display:'block', width:'100%'}}>{text ? text : '-'}</span>,
    // },
    {
      title: 'Final Bill',
      dataIndex: 'finalBill',
      key: 'finalBill',
      width: "1%",
      render: (text, record) => <span style={{display:'block', width:'100%'}}>{ text ? text == 0 ? "-" : `₹ ${Number(text).toLocaleString('en-IN')}` : "-"}</span>,
    },
    {
      title: 'Patient Status',
      dataIndex: 'patientStatus',
      key: 'patientStatus',
      width: '1%',
      render: (item, record) => {
        return (
          <>
            <Select
              value={record.patientStatus}
              style={{ width: '80%', borderRadius: '7px', backgroundColor: record.patientStatus==="Pending"? '#1966D2' : record.patientStatus==="Discharged"? '#C53929' : '#33A852' }}
              onChange={(val) => {patientStatusHandler(val, record._id); handleUpdateReadStatus(record._id)}}
              getPopupContainer={trigger => trigger.parentElement}
            >
              <Option
                disabled={record.status === "Pending"}
                value="Pending"
              >
                Pending
              </Option>
              <Option
                disabled={record.status === "Discharged"}
                value="Discharged"
              >
                Discharged
              </Option>
              <Option
                disabled={record.status === "Admitted"}
                value="Admitted"
              >
                Admitted
              </Option>
            </Select>
          </>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: "1%",
      render: (item, record) => {
        // { console.log({record:record.patientStatus}) }
        return (
          <div onClick={(e) => {
            e.stopPropagation();
            history.push(`/dashboard/booking/booking-details?id=${record._id}`)
            handleUpdateReadStatus(record._id)
          }}
          style={{cursor:'pointer', display:'block', width:'100%'}}
          >
            <div className="u-align-center">
              <span style={{ color: record.status==="UNDER PROCESS"? '#F8991D' : record.status==="INITIAL PENDING"? '#B4C4E1' : record.status==="INITIAL APPROVED"? '#0075DB' : record.status==="QUERIED"? '#627FB5' : record.status==="QUERY RECEIVED"? '#9747FF' : record.status==="FINAL APPROVED"? '#30C118' : record.status==="REJECTED"? '#E41212' : '#2C2B2B' }}>
                { record.status }
              </span>
              {/* <Select
                value={record.patientStatus}
                style={{ width: '80%', borderRadius: '7px', backgroundColor: record.patientStatus==="Pending"? '#1966D2' : record.patientStatus==="Discharged"? '#C53929' : '#33A852' }}
                onChange={(val) => patientStatusHandler(val, record._id)}
              >
                <Option
                  disabled={record.status === "Pending"}
                  value="Pending"
                >
                  Pending
                </Option>
                <Option
                  disabled={record.status === "Discharged"}
                  value="Discharged"
                >
                  Discharged
                </Option>
                <Option
                  disabled={record.status === "Admitted"}
                  value="Admitted"
                >
                  Admitted
                </Option>


              </Select> */}
            </div>
          </div>
        );
      },
    },
    // {
    //   title: 'Patient Status',
    //   dataIndex: 'patientStatus',
    //   key: 'patientStatus',
    //   width: "1%",
    //   render: (item, record) => {
    //     // { console.log({record:record.patientStatus}) }
    //     return (
    //       <div onClick={(e) => {
    //         e.stopPropagation();
    //       }}>
    //         <div className="u-align-center">
    //           <span style={{ color: record.patientStatus==="Pending"? '#1966D2' : record.patientStatus==="Discharged"? '#C53929' : '#33A852' }}>
    //             { record.status }
    //           </span>
    //           {/* <Select
    //             value={record.patientStatus}
    //             style={{ width: '80%', borderRadius: '7px', backgroundColor: record.patientStatus==="Pending"? '#1966D2' : record.patientStatus==="Discharged"? '#C53929' : '#33A852' }}
    //             onChange={(val) => patientStatusHandler(val, record._id)}
    //           >
    //             <Option
    //               disabled={record.status === "Pending"}
    //               value="Pending"
    //             >
    //               Pending
    //             </Option>
    //             <Option
    //               disabled={record.status === "Discharged"}
    //               value="Discharged"
    //             >
    //               Discharged
    //             </Option>
    //             <Option
    //               disabled={record.status === "Admitted"}
    //               value="Admitted"
    //             >
    //               Admitted
    //             </Option>


    //           </Select> */}
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: 'Card Number',
    //   dataIndex: 'cardNumber',
    //   key: 'cardNumber',
    //   width: "1%",
    //   render: text => <span>{text}</span>,
    // },
    {
      title: 'Date of Admission',
      dataIndex: 'doa',
      key: 'doa',
      width: "1%",
      render: (text, record) => <span style={{display:'block', width:'100%'}}>{text ? dayjs(text).format(dateFormat) : '-'}</span>,
    },
    {
      title: 'Date of Discharge',
      dataIndex: 'dod',
      key: 'dod',
      width: "1%",
      render: (text, record) => <span style={{display:'block', width:'100%'}}>{text ? dayjs(text).format(dateFormat) : '-'}</span>,
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: "1%",
      render: (text, record) => <span style={{display:'block', width:'100%'}}>{text ? dayjs(text).format(dateFormat) : '-'}</span>,
    },
    // {
    //   title: 'Time',
    //   dataIndex: 'time',
    //   key: 'time',
    //   width: "1%",
    //   render: text => <span>{text}</span>,
    // },
    // {
    //   title: 'Query Documents',
    //   dataIndex: 'queryDoc',
    //   key: 'queryDoc',
    //   width: "1%",
    //   align: "center",
    //   render: (docs, record) => <Button className="edit-session-button" onClick={(e) => {
    //     e.preventDefault()
    //     setQueryDocuments({
    //       _id: record._id,
    //       queryUrl: docs && docs.queryUrl ? docs.queryUrl : null,
    //       queryResponseUrl: docs && docs.queryResponseUrl ? docs.queryResponseUrl : null
    //     })
    //     setQueryDocFlag(true)
    //   }}>Open</Button>
    // },
    // {
    //   title: 'Insurance Documents',
    //   dataIndex: 'documents',
    //   key: 'documents',
    //   width: "1%",
    //   align: "center",
    //   render: (docs, record) => record.haveInsurance ? <Button className="edit-session-button" onClick={(e) => {
    //     e.preventDefault()
    //     let insCard = []
    //     if (docs.insuranceCard && docs.insuranceCard.length > 0) {
    //       docs.insuranceCard.map((card) => {
    //         insCard.push({
    //           imageUrl: card
    //         })
    //       })
    //       docs.insuranceCard = insCard
    //     }
    //     setInsuranceDocuments(docs)
    //     setDocModalFlag(true)
    //   }}>View Documents</Button> : "N/A"
    // },
    // {
    //   title: 'Rent Details',
    //   dataIndex: 'rentDetails',
    //   key: 'rentDetails',
    //   width: "1%",
    //   align: "center",
    //   render: (docs, record) => {return record.paymentDetails ? <Button className="edit-session-button" onClick={(e) => {
    //     e.preventDefault()
    //     setSelectedBooking({
    //       bookingId: record._id,
    //       roomRent: record.paymentDetails.roomRent,
    //       iCURent: record.paymentDetails.iCURent,
    //       dod: record.dod,
    //       doa: record.doa,
    //       nursingCharges: record.paymentDetails.nursingCharges,
    //       superSpecialityCharges: record.paymentDetails.superSpecialityCharges,
    //       cvc: record.paymentDetails.cvc,
    //       soa: record.paymentDetails.soa,
    //       others: record.paymentDetails.others,
    //       estimatedLengthOfStay: record.paymentDetails.estimatedLengthOfStay,
    //       totalBillAmount: record.paymentDetails.totalBillAmount,
    //       remarks: record.remarks
    //     })
    //     setRentDetailsFlag(true)
    //   }}>View Details</Button> : "N/A"},
    // },
    // {
    //   title: 'Discharge Documents',
    //   dataIndex: 'dischargeDoc',
    //   key: 'dischargeDoc',
    //   width: "1%",
    //   render: (text, record) => <Upload {...dischargeProps(record)}>
    //     <Button icon={<UploadOutlined />}>{text && text.docUploaded ? "Update " : "Upload "} Discharge Document</Button>
    //   </Upload>,
    // },
  ];

  const [data, setData] = useState([])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

  const initialProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadBookingQueryDoc?bookingId=${queryDocuments._id}&type=RESPONSE`,
    accept: "application/pdf",
    headers: {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) < 5
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please Upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        let tempData = data
        tempData.map((booking) => {
          if (booking._id == resBooking.bookingId) {
            booking.dischargeDocs = resBooking.dischargeDocs
          }
        })
        setData(tempData)
        message.success(`Query Document uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`Query Document upload failed.`);
      }
    },
  };

  const dischargeProps = (record) => ({
    name: 'file',
    action: `${get_v10_url()}/professional/uploadDischargeDocument?bookingId=${record._id}`,
    accept: "application/pdf",
    headers: {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        let tempData = data
        tempData.map((booking) => {
          if (booking._id == resBooking.bookingId) {
            booking.queryDoc = resBooking.queryDoc
            setQueryDocuments({ ...queryDocuments, queryUrl: resBooking.queryDoc.queryUrl })
          }
        })
        setData(tempData)
        message.success(`Query Document uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`Query Document upload failed.`);
      }
    },
  });

  const page_change = (a, b) => {
    setTableParams({ ...tableParams, page: a, limit: b })
    props.getBookingAL({ ...tableParams, page: a, limit: b })
  }

  const handleSearch = (selectedKeys, confirm, dataIndex, searchProp) => {
    // const nSearch={...search,[dataIndex]:selectedKeys[0]};
    // console.log({nSearch});
    confirm();
    setTableParams({
      ...tableParams, searchParams: search, page: 1
    })
    // props.getPatientDetails({ ...tableParams,searchParams: nSearch })
  }

  const handle_reset = (selectedKeys, confirm, dataIndex, searchProp) => {
    setSearch({ ...search, [dataIndex]: "" });
    const nSearch = { ...search, [dataIndex]: "" };
    // console.log({nSearch});
    // confirm();
    setTableParams({
      ...tableParams, searchParams: nSearch
    })
  }

  const getDateString = (date) => {
    let ts = date.split("-")
    ts = ts[0] + "-" + ts[1].charAt(0).toUpperCase() + ts[1].charAt(1).toLowerCase() + ts[1].charAt(2).toLowerCase() + "-" + ts[2]
    return ts
  }

  useEffect(() => {
    if (props.getBookingALRet) {
      let tableData = []
      if (props.getBookingALRet.success) {
        // if(props.getBookingALRet.total > 0) {
          // console.warn(props.getBookingALRet.data)
        props.getBookingALRet.data.map((booking, index) => {
          let apAmount = booking.paymentDetails? booking.paymentDetails.finalApproved ? booking.paymentDetails.finalApproved : booking.paymentDetails.initialApproved ? booking.paymentDetails.initialApproved : 0 : 0
          let obj = {
            _id: booking._id,
            time: dayjs(booking.createdAt).format(timeFormat),
            date: dayjs(booking.createdAt).format(dateFormat),
            name: booking.patientName,
            alNumber: booking.alNumber,
            netSanctionedAmount: booking.netSanctionedAmount ? booking.netSanctionedAmount : "Not Updated Yet",
            status: booking.preAuthStatus,
            paymentDetails: booking.paymentDetails,
            alLetterDetails: booking.alLetterDetails,
            cardNumber: booking.cardNumber,
            ipNumber: booking.ipNumber,
            dischargeDoc: booking.dischargeDoc,
            dod: booking.dod,
            doa: booking.doa,
            queryDoc: booking.queryDoc,
            hasReport: booking.userReportId,
            reportImages: booking.userReportId ? booking.reportImages : null,
            reportPdfs: booking.userReportId ? booking.reportPdfs : null,
            haveInsurance: booking.haveInsurance,
            documents: booking.insuranceDetails,
            remarks: booking.remarks,
            utr: booking.paymentDetails ? booking.paymentDetails.utr : null,
            alLetterUrl: booking.alLetterUrl,
            hospitalName: booking.professionalName,
            hospitalAddress: booking.professionalAddress,
            hospitalNumber: booking.professionalMobileNumber,
            policyNumber: booking.insuranceDetails ? booking.insuranceDetails.policyNumber : "N/A",
            patientStatus: booking.patientStatus,
            number: booking.userMobileNumber,
            patientStatus: booking.patientStatus,
            estimatedCost: booking?.paymentDetails?.sourcingCost,
            finalBill: booking?.paymentDetails?.finalBill,
            totalBill: booking?.paymentDetails?.totalBill,
            discountAmount: booking?.paymentDetails?.discount,
            approvedAmount: apAmount,
            amountDue: parseInt(apAmount) - parseInt((booking.paymentDetails && booking.paymentDetails.settledAmount) ? booking.paymentDetails.settledAmount : 0),
            settledAmount: booking?.paymentDetails?.settledAmount,
            isNewBooking: booking?.readStatus?.newBookingCashless ? booking?.readStatus?.newBookingCashless : false,
            plNumber: booking?.plNumber,
          }
          tableData.push(obj)
        })

        setTableParams({ ...tableParams, total: props.getBookingALRet.count })
        // console.log({ tableData: props.getBookingALRet.data });
        setData(tableData)
        scrollToTop()
      } else {
        openNotificationWithIcon()
      }
      props.getBookingALLoading()
    }
  }, [props.getBookingALRet])

  const openNotificationWithIcon = () => {
    notification["error"]({
      message: 'Could not fetch details',
      description:
        'Please try again later',
    });
  };

  const showTotal = (total) => {
    return `Total ${total} items`;
  }

  useEffect(() => {
    props.getBookingAL(tableParams)
  }, [tableParams.searchParams])

  const expand = (record, a, b) => {
    // console.log(record, a, b, "record,a,b")
    setModalData(record);
    if (expandedRowKeys[0] !== a._id) {
      // console.log(a,"IHIH");
      setExpandRowKeys([a._id])
    }
    else {
      setExpandRowKeys([])
    }
  }

  const handleDateRangeChanged = (e) => {
    if (e === null){
      setTableParams({
        ...tableParams,
        page: 1,
        filters: {
          ...tableParams.filters,
          date: ''
        }
      })
      props.getBookingAL({
        ...tableParams,
        page: 1,
        filters: {
          ...tableParams.filters,
          date: ''
        }
      })
    } else {
      const startDate = dayjs(e[0]._d).format('YYYY-MM-DD')
      const endDate = dayjs(e[1]._d).format('YYYY-MM-DD')
      setTableParams({
        ...tableParams,
        page: 1,
        filters: {
          ...tableParams.filters,
          date: `${startDate},${endDate}`
        }
      })
      props.getBookingAL({
        ...tableParams,
        page: 1,
        filters: {
          ...tableParams.filters,
          date: `${startDate},${endDate}`
        }
      })
    }
  }

  // if(loading) return <GlobalLoading />

  return (
    <>
      <Card
        title={(
          <div style={{display:'flex', alignItems:'center', gap:'0.75rem'}}>
            <img src={BookingIcon} alt='icon' style={{filter:'invert(61%) sepia(66%) saturate(4119%) hue-rotate(110deg) brightness(103%) contrast(105%)', height:'28px', width:'auto', marginBottom:'0.5rem'}}/>
            <h1 style={{color:'#01D35A'}}>Patient Details</h1>
          </div>
        )}
        className="bookings-card-container"
        headStyle={{ marginLeft: '180px', height: '64px' }}
        bodyStyle={{ padding: "0", height: '100%'}}
        style={{ height: '100%' }}
      >
        {/* <label className="details-search-label">AL Number</label> */}
        {/*<Search
              placeholder='Enter AL Number'
              className="al-search-bar"
              value={alNumber}
              onChange={(e) => setAlNumber(e.target.value)}
              onSearch={() => getBookingDetails()}
    />*/}
        <div className="patient-table-container booking-display-container">
          <div className='features-btn'>
            <Button className='filter-btn' icon={<div className='filter-icon'>{filterIcon}</div>} onClick={()=>setFilterModal(true)}>Filter</Button>
            {
              filterModal && <Filter closeFunc={() => setFilterModal(false)} tableParams={tableParams} setTableParams={setTableParams} handleChange={() => props.getBookingAL(tableParams)} />
            }
            <RangePicker className='date-picker' placeholder={['Select FROM', 'Select TO']} onChange={e => handleDateRangeChanged(e)} />
          </div>
          <Table
            key={0}
            scroll={{ x: 2500 }}
            columns={columns}
            dataSource={data}
            loading={props.bookingStore.getBookingALLoading || props.bookingStore.updateBookingLoading}
            pagination={{
              // showSizeChanger:true,
              limit: tableParams.limit,
              onChange: (a, c) => page_change(a, c),
              defaultCurrent: tableParams.page,
              current: tableParams.page,
              total: tableParams.total,
              // showTotal: showTotal,
              style: {
                marginRight: '20px'
              },
            }}
            className='booking-display-table'
            rowClassName="booking-table-row"
            // onRow={(record, rowIndex) => {
            //   return {
            //     onClick: event => history.push(`/dashboard/booking/booking-details?id=${record._id}`)
            //   };
            // }}
            // expandable={{ columnWidth: "1%" }}
            // expandedRowKeys={expandedRowKeys}
            // onExpandedRowsChange={(a, b, c) => console.log(a, b, c, 'onExpandedRowsChange')}
            // onExpand={(a, b, c) => expand(a, b, c)}
            rowKey={record => record._id}
            // expandedRowRender={record => <div key={record._id}>
            //   <BookingDetails
            //     finalBill={record.finalBill}
            //     totalBill={record.totalBill}
            //     discountAmount={record.discountAmount}
            //     bookingId={record._id}
            //     paymentDetails={record.paymentDetails}
            //   />
            // </div>
            // }
          />
        </div>
        <Modal
          title="Rent Details:"
          open={rentDetailsFlag}
          width={"80%"}
          onCancel={() => {
            setSelectedBooking(null)
            setRentDetailsFlag(false)
          }}
          onOk={() => {
            setSelectedBooking(null)
            setRentDetailsFlag(false)
          }}
        >
          {selectedBooking && <div className="container">
            <Row gutter={24}>
              <Col span={6}>
                <label className="session-label">Expected DOA</label>
                <DatePicker disabled={true} defaultValue={selectedBooking.doa && dayjs(getDateString(selectedBooking.doa), dateFormat)} disabledDate={(current) => current.isBefore(dayjs(dayjs(), dateFormat))} onChange={(date) => setSelectedBooking({ ...selectedBooking, doa: date.format(dateFormat) })} format={dateFormat} />
              </Col>
              <Col span={6}>
                <label className="session-label">Date of Discharge</label>
                <DatePicker disabled={true} defaultValue={selectedBooking.dod && dayjs(getDateString(selectedBooking.dod), dateFormat)} disabledDate={(current) => {
                  return selectedBooking.doa ?
                    current.isBefore(dayjs(getDateString(selectedBooking.doa), dateFormat))
                    : current.isBefore(dayjs(dayjs(), dateFormat))
                }} onChange={(date) => setSelectedBooking({ ...selectedBooking, dod: date.format(dateFormat) })} format={dateFormat} />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <label className="session-label">Room Rent</label>
                <Input disabled={true} value={selectedBooking.roomRent} onChange={(e) => setSelectedBooking({ ...selectedBooking, roomRent: e.target.value })} />
              </Col>
              <Col span={6}>
                <label className="session-label">ICU Rent</label>
                <Input disabled={true} value={selectedBooking.iCURent} onChange={(e) => setSelectedBooking({ ...selectedBooking, iCURent: e.target.value })} />
              </Col>
              <Col span={6}>
                <label className="session-label">Nursing Charges</label>
                <Input disabled={true} value={selectedBooking.nursingCharges} onChange={(e) => setSelectedBooking({ ...selectedBooking, nursingCharges: e.target.value })} />
              </Col>
              <Col span={6}>
                <label className="session-label">Consultant Visit Charges</label>
                <Input disabled={true} value={selectedBooking.cvc} onChange={(e) => setSelectedBooking({ ...selectedBooking, cvc: e.target.value })} />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <label className="session-label">Others</label>
                <Input disabled={true} value={selectedBooking.others} onChange={(e) => setSelectedBooking({ ...selectedBooking, others: e.target.value })} />
              </Col>
              <Col span={6}>
                <label className="session-label">Super Specialist Charges</label>
                <Input disabled={true} value={selectedBooking.superSpecialityCharges} onChange={(e) => setSelectedBooking({ ...selectedBooking, superSpecialityCharges: e.target.value })} />
              </Col>
              <Col span={6}>
                <label className="session-label">Surgeon Fee/OT/ Anaestheist</label>
                <Input disabled={true} value={selectedBooking.soa} onChange={(e) => setSelectedBooking({ ...selectedBooking, soa: e.target.value })} />
              </Col>
            </Row>
            {/* <Row gutter={24}>
                          <Col span={12}>
                              <label className="session-label">Remarks</label>
                              <TextArea rows={5} type='textarea' value={selectedBooking.remarks} onChange={(e) => setSelectedBooking({...selectedBooking, remarks: e.target.value})} />
                          </Col>
                      </Row> */}
          </div>}
        </Modal>
        <Modal
          title="Query Document"
          open={queryDocFlag}
          width={"70%"}
          onOk={() => setQueryDocFlag(false)}
          onCancel={() => setQueryDocFlag(false)}
        >
          <Row justify="space-around" gutter={24}>
            <Col span={8}>
              <label className="policy-label"><b>Submit Query </b></label>
              {queryDocuments && queryDocuments.queryUrl ? <label style={{ margin: "1.25rem 0" }} className="policy-label"><a href={queryDocuments.queryUrl}>Download Uploaded Document</a></label> : "No Query recieved"}
            </Col>
            <Col span={8}>
              <label className="policy-label"><b>Query Response</b></label>
              <Upload {...initialProps}>
                <Button icon={<UploadOutlined />}>{queryDocuments.queryResponseUrl ? "Update " : "Upload "} Query Document</Button>
              </Upload>
              {queryDocuments && queryDocuments.queryResponseUrl && <label style={{ margin: "1.25rem 0" }} className="policy-label"><a href={queryDocuments.queryResponseUrl}>Download Query Response</a></label>}
            </Col>
          </Row>
        </Modal>
        <Modal
          title="AL Letters"
          width={"50%"}
          closeIcon={false}
          open={alLetterFlag}
          footer={[
            <Button key='submit' type='primary' onClick={() => setAlLetterFlag(false)}>
              Okay
            </Button>
          ]}
        >
          {alLetterDetails && <>
            <Row gutter={24}>
              <Col style={{ textAlign: "center" }} span={12}>
                <label className="session-label">Initial Letter</label>
                {alLetterDetails.initialLetter ? <a href={alLetterDetails.initialLetter}>Download</a> : "Not Updated Yet"}
              </Col>
              <Col style={{ textAlign: "center" }} span={12}>
                <label className="session-label">Final Letter</label>
                {alLetterDetails.finalLetter ? <a href={alLetterDetails.finalLetter}>Download</a> : "Not Updated Yet"}
              </Col>
            </Row>
          </>}
        </Modal>
        <Modal
          title="Insurance Documents"
          closeIcon={false}
          width={"50%"}
          open={docModalFlag}
          footer={[
            <Button key='submit' type='primary' onClick={() => setDocModalFlag(false)}>
              Okay
            </Button>
          ]}
        >
          <Row gutter={24}>
            <Col span={12}>
              <label className="session-label">Policy Number</label>
              <span className="policy-text">{insuranceDocuments.policyNumber}</span>
            </Col>
            <Col span={12}>
              <label className="session-label">Insurance Partner</label>
              <span className="policy-text">{insuranceDocuments.insurancePartner}</span>
            </Col>
          </Row>
          <Row gutter={24}>
            {insuranceDocuments.insurancePolicy && <Col span={12}>
              <label className="session-label">Insurance PDF</label>
              <a className="edit-session-button policy" href={insuranceDocuments.insurancePolicy}>Download</a>
            </Col>}
            {/* {insuranceDocuments.insuranceCard && insuranceDocuments.insuranceCard.length > 0 && <Col span={12}>
                    <label className="session-label">Insurance Card</label>
                    <PhotoGallery id="insurance-card" data={insuranceDocuments.insuranceCard} />
                  </div>}  */}
          </Row>
        </Modal>
      </Card>
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.authStore,
  bookingStore: state.bookingStore,
  getBookingALLoadingFlag: state.bookingStore.getBookingALLoading,
  getBookingALRet: state.bookingStore.getBookingALRet,
  updateBookingLoadingFlag: state.bookingStore.updateBookingLoading,
  updateBookingRet: state.bookingStore.updateBookingRet,
});

export default connect(mapStateToProps, {
  getBookingAL,
  getBookingALLoading,
  updateBooking,
  updateBookingLoading
})(Bookings);